import {
  ADD_QUEUE_PROJECT,
  ADD_VISIBLE_IN_CARD,
  GET_FILTERED_PROJECT_USERS,
  GET_PROJECTS,
  GET_PROJECT_USERS,
  GET_SELECTS,
  STORE_SORTING_ORDER,
} from "../../actions/action-types";
import { alertNotification } from "../../actions/alertNotification";
import { showProjectsSidebarOnTop } from "../../actions/latestSidebar";
import { setProjectSettingsData } from "../../actions/projectSettings";
import {
  changeProjectSidebar,
  setProjectDetails,
  setProjectLoader,
  setSelectedProjectSection,
  setSelectedTab,
  setStageList,
  toggleProjectSidebar,
} from "../../actions/projectSidebar";
import { addProjectWorkflows } from "../../actions/projectWorkflows";
import {
  addProjectAction,
  addProjectMemberAction,
  deleteProjectMemberAction,
  setLastFilterId,
  setNewProject,
  setTeamFilterDetails,
  setTeamSavedFilter,
  storeTeamFilterUtilities,
  updateProjectAction,
} from "../../actions/projects";
import { updateAllQueues } from "../../actions/queue";
import { addNewFilterToFilterList, setFilteredTaskList } from "../../components/DynamicFilters/services/filter.service.helper";
import { PROJECT_TYPE, sidepanelOptions } from "../../components/ProjectSidebar/projectSidebar.constants";
import { formatArrDataValuesToKey, formatKeysAndData } from "../../components/Queues/QueueTasks/queue.common";
import { teamFilterPayloadSelectedView } from "../../components/DynamicFilters/FilterSettings/filterView.helpers";
import { getDefaultTaskValues, getTasks, quickFilterCardsCount } from "../../components/Tasks/tasks.service";
import { AUTH_TOKENS, label, notifyIcon, number, quote, requestMethod, route } from "../../config/";
import config from "../../env.config";
import store from "../../store";
import { checkApiSuccess } from "../../utils/";
import { createDynamicTeamName, getNotification } from "../../utils/common";
import { groupRows } from "../../utils/kendo";
import { fetch } from "./api.service";
import { getAddProjectPayload, getCreateProjectPayload } from "./service.helper";
import { loadState } from "./session.service";

const getAllProjectsAndNotification = async (response) => {
  const state = store.getState();
  const { operationalTeamName } = state.auth.user;
  
  /** Try to find project by p_ProjectId from response, or by name and queue if not available
   */
  const projectId = response?.data?.data?.p_ProjectId;
  
  projectId
    ? store.dispatch(alertNotification(true, createDynamicTeamName(response.data.message, operationalTeamName), notifyIcon.SUCCESS_ICON))
    : store.dispatch(alertNotification(true, response.data.message, notifyIcon.ERROR_ICON));
};

export const addQueueProject = (payload) => {
  return {
    type: ADD_QUEUE_PROJECT,
    payload: payload,
  };
};

const quickFilterCards = {
  QUICK_FILTER_ONE: "quickFilterOne",
  QUICK_FILTER_TWO: "quickFilterTwo",
  QUICK_FILTER_THREE: "quickFilterThree",
  QUICK_FILTER_FOUR: "quickFilterFour",
  QUICK_FILTER_FIVE: "quickFilterFive",
  QUICK_FILTER_SIX: "quickFilterSix",
};

/**
 * It returns quickFilterData for corresponding quickFilter
 * @param {Number} quickFilter
 * @returns {Object} quickFilterData
 * @author Muskan Thakur
 */
export const quickFilterData = (quickFilter) => {
  if (quickFilter == number.ONE) return quickFilterCards.QUICK_FILTER_ONE;
  if (quickFilter == number.TWO) return quickFilterCards.QUICK_FILTER_TWO;
  if (quickFilter == number.THREE) return quickFilterCards.QUICK_FILTER_THREE;
  if (quickFilter == number.FOUR) return quickFilterCards.QUICK_FILTER_FOUR;
  if (quickFilter == number.FIVE) return quickFilterCards.QUICK_FILTER_FIVE;
  if (quickFilter == number.SIX) return quickFilterCards.QUICK_FILTER_SIX;
};

/**
 * opens project sidebar
 * @param {String} type
 * @param {Integer} projectId
 */
export const openProjectSidebar = async (type, projectId, tabIndex) => {
  if (!type && !projectId) return;
  store.dispatch(setProjectLoader(true));
  await store.dispatch(toggleProjectSidebar({ type, showProjectSidebar: true }));
  store.dispatch(showProjectsSidebarOnTop());
  store.dispatch(changeProjectSidebar());
  type === PROJECT_TYPE.PERSONAL_PROJECT &&
    store.dispatch(setSelectedProjectSection([sidepanelOptions[number.ONE].id, sidepanelOptions[number.TWO].id]));
  store.dispatch(setSelectedTab(tabIndex ? tabIndex : number.ZERO));
  const state = store.getState();
  const user = state.auth.user;
  let projectDetail = await store.dispatch(getProjectDetails({ userId: user.id, projectId, companyId: user.companyId }));
  projectDetail?.projectDetails?.ProjectId && (await store.dispatch(setProjectLoader(false)));
};

/**
 * handling api for adding queue
 * @param {data}
 * @returns {void}
 * @author Prachi Jain
 */

export const addProject = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/project/addNewProject`,
      data: data,
    };
    await fetch(requestConfig, true, false);
  };
};

export const createProject = (data, history) => {
  const workspacePage = data.workspacePage;
  delete data["workspacePage"];
  return async (dispatch, getState) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/project/addProject`,
      data: data,
    };
    const user = loadState(AUTH_TOKENS.USER);
    const state = store.getState();
    const queues = state.allQueues;
    const selectedQueue = queues?.find((item) => item.QueueId === data?.queue);
    const newCount = selectedQueue?.projectCount + number.ONE;
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      let projectId = response?.data?.data?.p_ProjectId;

      if (projectId) {
        const payload = getCreateProjectPayload(data, response);
        store.dispatch(setNewProject(payload));
        if (workspacePage) {
          addProjectWorkspacePage(response, data, newCount, dispatch);
          return projectId ;
        } else {
          const newProject = getAddProjectPayload(data, response?.data.data);
          await dispatch(addProjectAction(newProject));
          addProjectProjectPage(response, data, user, history, projectId);
        }
      } else {
        const operationalTeamName = state.auth?.user?.operationalTeamName;
        dispatch(alertNotification(true, createDynamicTeamName(response.data.message, operationalTeamName), notifyIcon.SUCCESS_ICON));
      }
    } else if (response) {
      dispatch(alertNotification(true, response.data.message, notifyIcon.ERROR_ICON));
    }
  };
};

/**
 * Used to handle add Project when Project is added through workspace page
 */
const addProjectWorkspacePage = async (response, data, newCount, dispatch) => {
  const projectId = response?.data?.data?.p_ProjectId;
  /** Only proceed if project ID exists in response
   */
  if (projectId) {
    const Queuepayload = { QueueId: data.queue, projectCount: newCount };
    await dispatch(updateAllQueues(Queuepayload));
    getNotification(quote.TEAM_ADDED, notifyIcon.SUCCESS_ICON);
  }
};

/**
 * Used to handle add Project when Project is added through project page
 */
const addProjectProjectPage = async (response, data, user, history, projectIdFromCreate) => {

  const projectId = projectIdFromCreate || response?.data?.data?.p_ProjectId;
     if(projectId) history.push(`${route.PRIVATE_ROUTE.TEAM_SETTING.PATH}/${projectId}`);

  getAllProjectsAndNotification( response);
};

/**
 * handling api for getting all projects
 * @returns {void}
 * @author Prachi Jain
 */

export const getAllProjects = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/project/getCompanyProjects`,
      params: payload,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(storeProjects(response.data.data));
      return response.data.data.data;
    }
  };
};

export const getProjectsWithWorkInfo = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/project/getProjectsWithWorkInfo`,
      params: payload,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(storeProjects(response.data.data));
      return response.data.data.data;
    }
  };
};

/**
 * saving the projects in redux store
 * @param {*} projects
 * @returns {type Of Action}
 * @returns {list of projects to set}
 */

export const storeProjects = (projects) => {
  return {
    type: GET_PROJECTS,
    payload: projects,
  };
};

/**
 * handling api for getting all project selects
 * @returns {void}
 * @author Prachi Jain
 */

export const getProjectSelects = () => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/project/getProjectSelects`,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(storeSelects(response.data.data));
    }
  };
};

/**
 * saving the project selects in redux store
 * @param {*} projects
 * @returns {type Of Action}
 * @returns {list of users to set}
 */

export const storeSelects = (selectOptions) => {
  return {
    type: GET_SELECTS,
    options: selectOptions,
  };
};

export const updateProjectNew = (data) => {
  const state = store.getState();
  const { operationalTeamName } = state.auth.user;
  const allQueues = state.allQueues;
  let queueName;
  if (data?.queue) {
    const queue = allQueues.find((queue) => queue.QueueId === data?.queue);
    queueName = queue ? queue?.QueueName : undefined;
  }
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/project/updateProjects`,
      data: data,
    };
    var user = loadState(AUTH_TOKENS.USER);
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      const payload = {
        ProjectId: data?.projectId,
        ProjectName: data?.name,
        ProjectCode: data?.projectCode,
        QueueId: data?.queue,
        QueueName: queueName,
        StartDate: data?.startDate,
        EndDate: data?.endDate,
        ProjectStatus: data?.projectStatus,
        DefaultView: data?.defaultView,
      };
      await store.dispatch(updateProjectAction(payload));
      // await fetchDefaultTaskValuesHelper(user.companyId, user.id);
      response.data.data
        ? store.dispatch(alertNotification(true, createDynamicTeamName(response.data.message, operationalTeamName), notifyIcon.SUCCESS_ICON))
        : data.projectCode === ""
        ? store.dispatch(alertNotification(true, "Team code cannot be empty", notifyIcon.ERROR_ICON))
        : store.dispatch(alertNotification(true, response.data.message, notifyIcon.ERROR_ICON));
    }
  };
};

/**
 * add users to a project
 * @param {data}
 * @returns {void}
 * @author Prachi Jain
 */

export const addProjectUsers = (data) => {
  return async (dispatch, getState) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/project/addProjectUsers`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    response = response?.data?.data;
    const state = getState();
    const { projectMembers } = state?.team;

    if (response) {
      response?.forEach((addUser) => {
        dispatch(addProjectMemberAction(addUser));
      });
      const newMemberCount = projectMembers?.length;
      const projectPayload = {
        ProjectId: data?.projectId,
        members: newMemberCount,
      };
      dispatch(updateProjectAction(projectPayload));
    }
  };
};

/**
 * handling api for getting all users of a project
 * @returns {void}
 * @author Prachi Jain
 */

export const getProjectUsers = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/project/getProjectUsers`,
      params: {
        entityId: payload.entityId,
        companyId: payload.companyId,
      },
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(storeTeam(response.data.data.TeamMembers));
      dispatch(addVisibleInCard(response.data.data.VisibleInCard));
      dispatch(storeSortingOrder(response.data.data.SortingOrder));
      return response.data.data;
    }
  };
};

/**
 * saving the users of a project in redux store
 * @param {*} projects
 * @returns {type Of Action}
 * @returns {list of users to set}
 */

export const storeTeam = (users) => {
  return {
    type: GET_PROJECT_USERS,
    users: users,
  };
};

export const addVisibleInCard = (visibleInCard) => {
  return {
    type: ADD_VISIBLE_IN_CARD,
    visibleInCard: visibleInCard,
  };
};

export const storeSortingOrder = (sortingOrder) => {
  return {
    type: STORE_SORTING_ORDER,
    sortingOrder: sortingOrder,
  };
};
/**
 * saving the filtered users of a project in redux store
 * @param {*} projects
 * @returns {type Of Action}
 * @returns {list of users to set}
 */

export const storeFilteredTeam = (search) => {
  return {
    type: GET_FILTERED_PROJECT_USERS,
    search: search,
  };
};

/**
 * handling api for updating users of project
 * @param {data}
 * @returns {void}
 * @author Prachi Jain
 */

export const updateUserRole = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/project/updateUserRole`,
      data: data,
    };
    var user = loadState(AUTH_TOKENS.USER);
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      const payload = {
        UserId: data.data.teamMember,
        RoleId: +data.data.roleId,
      };
      checkAdmin(user.isAdmin)
        ? dispatch(getAllProjects(payload)) && dispatch(getProjectUsers(data.entityId))
        : dispatch(getProjectUsers(data.entityId));
    }
  };
};

/**
 * handling api for deleting users from project
 * @param {data}
 * @returns {void}
 * @author Prachi Jain
 */

export const deleteProjectUser = (data) => {
  return async (dispatch, getState) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/project/deleteProjectUser`,
      data: data,
    };
    const state = getState();
    let response = await fetch(requestConfig, false, false);
    const { projectMembers } = state.team;
    if (checkApiSuccess(response)) {
      const projectPayload = {
        ProjectId: data.entityId,
        members: projectMembers?.length - number.ONE,
      };
      dispatch(getDefaultTaskValues(state.auth.user.companyId, state.auth.user.id));
      dispatch(updateProjectAction(projectPayload));
      dispatch(deleteProjectMemberAction(data.deletedUser));
    }
  };
};

export const checkRemoveTeamUser = async (payload) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/project/checkRemoveTeamUser`,
    params: payload,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Handles API call for adding project join request
 * @author Muskan Thakur
 */
export const addProjectRequest = async (reqBody) => {
  if (!reqBody || !reqBody.uId || !reqBody.projectId) {
    return null;
  }

  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/project/addProjectRequest`,
    data: {
      uId: reqBody.uId,
      projectId: reqBody.projectId,
    },
  };

  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response;
  }
  return response;
};

/**
 * Handles API call for accepting or rejecting project join request
 * @author Muskan Thakur
 */
export const acceptRejectProjectRequest = async (reqBody) => {
  if (!reqBody || !reqBody.uId || !reqBody.projectId || reqBody.isAccepted === undefined) {
    return null;
  }

  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/project/acceptRejectProjectRequest`,
    data: {
      uId: reqBody.uId,
      projectId: reqBody.projectId,
      acceptedBy: reqBody.acceptedBy,
      isAccepted: reqBody.isAccepted,
    },
  };

  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response;
  }
  return response;
};

/**
 * gets project details
 * @param {*} payload
 * @returns
 */
export const getProjectDetails = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/project/getProjectDetails`,
      params: payload,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      const { priorityList, stageList, privacyList, projectDetails, QueueName, tagList, viewList, status, delegateOptions } = response.data.data;

      dispatch(setProjectSettingsData({ priorityList, privacyList, QueueName, tagList, viewList, status, delegateOptions }));
      dispatch(setProjectDetails(projectDetails));
      dispatch(setStageList(stageList));
      return response.data.data;
    }
  };
};

export const isNewStreamAdded = async (userId, projectId) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/project/isNewStreamAdded`,
    data: { userId, projectId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const saveProjectStages = (data) => {
  return async () => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/project/saveProjectStages`,
      data: data,
    };
    await fetch(requestConfig, false, true);
  };
};

export const getProjectWorkflows = (data) => {
  return async (dispatch) => {
    const params = {};
    if (data?.projectId) {
      params.projectId = data.projectId;
    }
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/project/getProjectWorkflows`,
      params,
    };
    let response = await fetch(requestConfig, false, true);
    if (checkApiSuccess(response)) {
      const workflows = response.data.data;
      if (data?.projectId) {
        dispatch(addProjectWorkflows({ projectId: data.projectId, workflows }));
      }
      return workflows;
    }
  };
};

export const getTeamDefaultFilterValues = (projectId) => async (dispatch, getState) => {
  const store = getState();
  const userId = store.auth.user.id;
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/project/getTeamDefaultFilterValues`,
    params: {
      userId,
      projectId,
    },
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
  }
};

/**
 * Slim "create filter" call for the Add Filter sidebar (metadata-only creation).
 * Reuses the same /project/saveTeamFilter endpoint as saveTeamFilter, but posts only the basic
 * fields (filterName, description, isMyBoard, createdBy) without any teamFilterData / variables /
 * sortedSelectedVariables payload. Returns response.data.data on success, otherwise null.
 */
export const saveTeamFilterDetails =
  ({ filterName, description, projectId, isMyBoard, createdBy }) =>
  async () => {
    const requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/project/saveTeamFilter`,
      params: { projectId },
      data: {
        filterName,
        description: description ?? "",
        isMyBoard: !!isMyBoard,
        createdBy,
      },
    };
    const response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data?.data ?? null;
    }
    return null;
  };

export const saveTeamFilter = (projectId) => async (dispatch, getState) => {
  const store = getState();
  const { teamFilterData } = store.teamFilter;
  const { user } = store.auth;
  const sortedSelectedVariablesJson = teamFilterData?.sortedSelectedVariables ? JSON.stringify(teamFilterData.sortedSelectedVariables) : null;
  let requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/project/saveTeamFilter`,
    params: { projectId: projectId ?? store.auth.user.myProjectId },
    data: {
      ...formatArrDataValuesToKey(teamFilterData),
      sortedSelectedVariables: sortedSelectedVariablesJson,
      isMyBoard: !projectId,
      selectedView: teamFilterPayloadSelectedView(teamFilterData),
      isGrouping: Boolean(teamFilterData?.enableGrouping),
      isTotals: Boolean(teamFilterData?.isTotals),
      isSubtotals: Boolean(teamFilterData?.isSubtotals),
    },
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    const { tasks, newFilterId } = response.data.data;
    if (newFilterId) {
      teamFilterData.quickFilter && dispatch(quickFilterCardsCount(user.id, projectId ?? user.myProjectId));
      await dispatch(setLastFilterId(newFilterId));
      addNewFilterToFilterList(newFilterId);
      setFilteredTaskList(projectId, tasks);
    } else {
      getNotification(response.data.message, notifyIcon.ERROR_ICON);
    }
  }
};

export const updateTeamFilterByFilterId = (filterId, projectId, filterGroup, isPinnedNotification) => async (dispatch, getState) => {
  const store = getState();
  const { teamFilterData, teamSavedFilters } = store.teamFilter;
  const { user } = store.auth;
  const selectedFilterGroup = teamSavedFilters?.find((f) => f.value === filterId)?.filterGroup;
  const sortedSelectedVariablesJson = teamFilterData?.sortedSelectedVariables ? JSON.stringify(teamFilterData.sortedSelectedVariables) : null;
  
  const isSheetView = user.lastSelectedBoard === label.SHEET;
  let requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/project/updateTeamFilter`,
    params: { filterId, projectId: projectId ?? user.myProjectId },
    data: {
      ...formatArrDataValuesToKey({ ...teamFilterData }),
      sortedSelectedVariables: sortedSelectedVariablesJson,
      filterGroup: filterGroup ? groupRows(filterGroup) : selectedFilterGroup,
      isMyBoard: projectId ? (user.myProjectId === projectId ? 1 : 0) : !projectId,
      selectedView: teamFilterPayloadSelectedView(teamFilterData),
      isGrouping: Boolean(teamFilterData?.enableGrouping !== false),
      isTotals: Boolean((teamFilterData?.isTotals)),
      isSubtotals: Boolean((teamFilterData?.isSubtotals)),
      ...(user?.id != null ? { userId: user.id } : {}),
    },
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    const { tasks, teamSavedFilters } = response.data.data;
    const onUserProfileSettings =
      typeof window !== "undefined" && window.location?.pathname?.startsWith(route.PRIVATE_ROUTE.USER_PROFILE_SETTING.PATH);
    if (!onUserProfileSettings) {
    getNotification(
      isPinnedNotification ? `${label.FILTER_PIN_POSITION} ${teamFilterData?.quickFilter}` : response.data.message,
      notifyIcon.SUCCESS_ICON
    );
    teamFilterData.quickFilter && dispatch(quickFilterCardsCount(user.id, projectId ?? user.myProjectId));
    await dispatch(setLastFilterId(filterId));
        dispatch(setTeamSavedFilter([...teamSavedFilters]));
    if (isSheetView) {
      await dispatch(getTeamFilterByFilterId(filterId, sortedSelectedVariablesJson.length > 0));
      getTasks(null, true, false, false);
    } else {
      setFilteredTaskList(projectId, tasks);
    }
  }
  }
};

export const getTeamSavedFilter = (params) => async (dispatch) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/project/getTeamFilters`,
    params: params,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    const { teamSavedFilters } = response.data.data;
    dispatch(setTeamSavedFilter(teamSavedFilters));
    return response.data.data;
  }
  return null;
};

export const updateLastTeamFilter = (projectId, filterId) => async (dispatch, getState) => {
  const store = getState();
  const userId = store.auth.user.id;
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/project/updateLastTeamFilter`,
    params: { userId, projectId },
    data: { filterId: filterId ?? null },
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    dispatch(setLastFilterId(filterId));
  }
};

export const getTeamFilterByFilterId = (filterId) => async (dispatch) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/project/getTeamFilterByFilterId`,
    params: { filterId },
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    const formattedData = formatKeysAndData(response.data.data);
    if (formattedData.sortedSelectedVariables && typeof formattedData.sortedSelectedVariables === "string") {
      formattedData.sortedSelectedVariables = JSON.parse(formattedData.sortedSelectedVariables);
    } else if (!formattedData.sortedSelectedVariables) {
      formattedData.sortedSelectedVariables = [];
    }
    if (!formattedData.isGrouping) {
      formattedData.enableGrouping = Boolean(Number(formattedData.isGrouping));
    }
    dispatch(setTeamFilterDetails(formattedData));
  }
};

export const deleteTeamFilterByFilterId = (filterId, userId, projectId, source) => async (dispatch) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/project/deleteTeamFilter`,
    data: { filterId, userId, isPersonal: !projectId },
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    const { tasks, defaultQuickFilter } = response.data.data;
    await dispatch(setLastFilterId(defaultQuickFilter));
    if (source !== label.FILTERS) {
      getTasks(null, true);
    setFilteredTaskList(projectId, tasks);
    }
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
  }
};

export const checkTeamFilterNameExists = (filterName) => async () => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/project/checkTeamFilterNameExists`,
    params: { filterName },
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data.data.filterExists;
  }
};

export const getFavouriteFilters = () => async () => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/project/getFavouriteFilters`,
    params: {},
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};


export const addUpdateFavouriteFilters = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/project/addUpdateFavouriteFilters`,
    data: payload,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};


export const saveFavouriteFilterOrder = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/project/saveFavouriteFilterOrder`,
    data: payload,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};


export const getTeamFilterUtilities = (projectId) => async (dispatch) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/project/getTeamFilterUtilities`,
    params: { projectId },
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    dispatch(storeTeamFilterUtilities(response.data.data));
  }
};

export const getProjectDefaults = async (companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/project/getProjectDefaults`,
    params: { companyId },
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const addUpdateManageProjectFilter = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/project/addUpdateManageProjectFilter`,
    data: payload,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getProjectWorkflowAndForms = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/project/getProjectWorkflowAndForms`,
      params: {
        projectId: data.projectId,
      },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const getProjectsForAdmin = (bodyData) => {
  return async (dispatch) => {
    const requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/admin/getProjectsForAdmin`,
      data: bodyData,
    };
    const response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const getProjectFilterUtilities = async () => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getProjectFilterUtilities`,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

